import { render, staticRenderFns } from "./WorklistEdit.vue?vue&type=template&id=6155c704&"
import script from "./WorklistEdit.vue?vue&type=script&lang=js&"
export * from "./WorklistEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports